module.exports = __webpack_public_path__ + "img/13f.61201fcf.png";